import React from 'react';

const PromoCard = ({ values, animationDelay }) => {

  // Parse and render HTML safely
  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
    <li className="featured__item react" style={animationDelay}>
      <div className="featured__item_link">
        <section className="grid-item promo-section">
          <div className="promo">
            <article className={"promo__item" + ' ' + values.color}>
              <div className="promo__item-img-container">
                <img className="promo__item-img" src={values.image} alt=""></img>
              </div>
              <div className="promo__item-content flow">
                <h2 className="promo__item-title h4">{values.title}</h2>
                <div className="promo__item-text" dangerouslySetInnerHTML={createMarkup(values.text)}></div>
                <div className="card__button-container">
                  <a className="btn" href={values.link}>{values.linktxt}</a>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </li>
  );
};

export default PromoCard;
